var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('Hero'),_c('NewsSection'),_c('Info'),_c('DeviceStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }